import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { TrackedBookingLink } from "@/components/TrackedBookingLink";
import { useCookieBannerVisible } from "@/hooks/useCookieBannerVisible";
import { analytics } from "@/lib/analytics";
import { cn } from "@/lib/utils";

export function MobileStickyCTA() {
  const { pathname } = useLocation();
  const bannerVisible = useCookieBannerVisible();
  const [show, setShow] = useState(false);
  const impressionLoggedFor = useRef<string | null>(null);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Fire one impression per page when the bar first becomes visible
  useEffect(() => {
    if (!show) return;
    if (impressionLoggedFor.current === pathname) return;
    impressionLoggedFor.current = pathname;
    analytics.stickyCtaImpression(pathname);
  }, [show, pathname]);

  if (pathname.startsWith("/admin") || pathname === "/contact") return null;
  if (bannerVisible) return null;

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 px-4 py-3 transition-transform duration-300",
        show ? "translate-y-0" : "translate-y-full"
      )}
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <TrackedBookingLink
        placement="mobile_sticky"
        onClick={() => analytics.stickyCtaClick(pathname)}
        className="w-full gradient-orange border-0 text-sm font-semibold hover-glow"
      >
        Book a Free Discovery Call <Phone className="ml-2 h-4 w-4" />
      </TrackedBookingLink>
    </div>
  );
}
